export const SUB_USER_ROLES = [
  {
    key: "analyst",
    label: "Analyst",
    description: "View dashboards & reports",
    badge: "ANALYST",
  },
  {
    key: "manager",
    label: "Manager",
    description: "Edit data & invite users",
    badge: "MANAGER",
  },
  {
    key: "account_admin",
    label: "Account Admin",
    description: "Full access incl. billing",
    badge: "ACCOUNT ADMIN",
  },
];

export const SUB_USER_MODULES = [
  { key: "dashboard", label: "Dashboard", icon: "ki-element-11" },
  { key: "products", label: "Products", icon: "ki-directbox-default" },
  { key: "alerts", label: "Alerts", icon: "ki-notification-on" },
  { key: "expenses", label: "Expenses", icon: "ki-finance-calculator" },
  { key: "ai_chat", label: "AI Chat", icon: "ki-abstract-26" },
  { key: "data_logs", label: "Import & Export", icon: "ki-cloud-add" },
  { key: "advanced_settings", label: "Advanced Settings", icon: "ki-setting-2" },
  { key: "user_settings", label: "User Settings", icon: "ki-user" },
  { key: "billing", label: "Billing", icon: "ki-wallet" },
  { key: "child_sellers", label: "Seller Accounts", icon: "ki-people" },
  { key: "sub_users", label: "Manage Users", icon: "ki-profile-user" },
];

export const ROLE_LABEL_MAP = Object.fromEntries(
  SUB_USER_ROLES.map((r) => [r.key, r.label])
);

export const MODULE_LABEL_MAP = Object.fromEntries(
  SUB_USER_MODULES.map((m) => [m.key, m.label])
);

export function mapSellerAccessToAccountAccess(sellerAccess = []) {
  return sellerAccess.map((entry) => ({
    account_id: entry.seller_user_id,
    account_name: entry.seller_name || entry.name || `Account ${entry.seller_user_id}`,
    marketplace: entry.marketplace || "",
    category: entry.category || "",
    enabled: !!entry.enabled,
    modules: entry.page_permissions || [],
  }));
}

export function buildDefaultAccountAccess(accounts = []) {
  return accounts.map((acc) => ({
    account_id: acc.id,
    account_name: acc.name || acc.seller_name || acc.email || `Account ${acc.id}`,
    marketplace: acc.marketplace || "",
    category: acc.category || acc.seller_category || "",
    enabled: false,
    expanded: false,
    modules: [],
  }));
}

export const SUB_USER_STATUS_LABELS = {
  active: "Active",
  pending: "Pending",
  disabled: "Disabled",
  invite_sent: "Pending",
};

export function normalizeSubUserRecord(record) {
  const roleKey = record?.sub_user_role || record?.role || "analyst";
  const rawStatus = record?.sub_user_status || record?.status || "active";
  const status = rawStatus === "invite_sent" ? "pending" : rawStatus;

  return {
    id: record?.id,
    name: record?.name || "",
    email: record?.email || "",
    role: roleKey,
    status,
    sub_user_status: record?.sub_user_status,
    accounts_count:
      record?.accounts_count ??
      record?.seller_access?.filter((s) => s.enabled)?.length ??
      0,
    modules_count: record?.modules_count ?? 0,
    created_at: record?.created_at,
    seller_access: record?.seller_access || [],
  };
}
